<div
  class="chatbot-messages-body flex-grow-1 overflow-auto d-flex flex-column gap-3 px-3 py-3"
  ref="messages_body"
  @scroll.passive="handle_scroll"
  @click="handle_message_click"
>
  <div
    v-if="has_older_messages"
    class="d-flex justify-content-center"
  >
    <button
      type="button"
      class="btn btn-sm btn-outline-light border-opacity-25 rounded-pill d-inline-flex align-items-center gap-2 text-xs"
      :disabled="is_loading_older_messages"
      @click="$emit('load-older-messages')"
    >
      <i class="bi bi-arrow-up-circle"></i>
      <span>{{ is_loading_older_messages ? "Loading" : "Older messages" }}</span>
    </button>
  </div>

  <div
    v-for="(msg, index) in messages"
    :key="msg.id || 'msg-' + index"
    class="chatbot-message-row d-flex align-items-start gap-2 w-100"
    :class="msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'"
  >
    <span
      v-if="msg.sender !== 'user'"
      class="chatbot-avatar chatbot-avatar-sm d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-circle"
      aria-hidden="true"
    >
      <i class="bi bi-robot"></i>
    </span>

    <div
      class="chatbot-message-group d-flex flex-column gap-1"
      :class="msg.sender === 'user' ? 'chatbot-message-group-user align-items-end' : 'chatbot-message-group-assistant align-items-start'"
    >
      <div
        v-if="msg.sender === 'user'"
        class="chatbot-bubble chatbot-bubble-user text-white px-3 py-2"
      >{{ msg.text }}</div>

      <div
        v-else
        class="chatbot-bubble chatbot-bubble-assistant text-white"
        :class="msg.is_typing ? 'chatbot-bubble-thinking-shell p-0' : 'px-3 py-2'"
      >
        <div
          v-if="msg.is_typing"
          class="chatbot-thinking chatbot-soft-bg w-100 p-3 border border-light border-opacity-10"
          aria-label="AI Campus VSI is thinking"
        >
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <span class="fw-semibold">Working on your request</span>
            <span
              class="badge rounded-pill bg-white bg-opacity-10 fw-normal"
              :class="get_thinking_status_class(msg)"
            >
              {{ get_thinking_status_label(msg) }}
            </span>
          </div>

          <div class="d-flex flex-column gap-2">
            <div
              v-for="(step, step_index) in msg.thinking_steps"
              :key="step.label || step_index"
              class="d-flex align-items-start gap-2 text-white-50"
            >
              <span
                class="chatbot-thinking-check d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-circle text-white"
                :class="get_thinking_step_class(step)"
                aria-hidden="true"
              >
                <i v-if="step.status === 'complete'" class="bi bi-check-lg"></i>
                <i v-else-if="step.status === 'failed'" class="bi bi-x-lg"></i>
                <i v-else class="bi bi-arrow-repeat chatbot-spin"></i>
              </span>
              <span class="d-flex flex-column overflow-hidden">
                <span class="text-white">{{ step.label }}</span>
                <span class="text-xs">{{ step.detail }}</span>
              </span>
            </div>
          </div>
        </div>
        <div
          v-else
          class="d-block"
        >
          <div
            v-for="(block, block_index) in get_message_blocks(msg)"
            :key="block_index"
          >
            <strong
              v-if="block.type === 'heading'"
              class="d-block mt-2 mb-1"
            >
              {{ block.text }}
            </strong>
            <template v-else>
              <template
                v-for="(part, part_index) in block.parts"
                :key="part_index"
              >
                <a
                  v-if="part.type === 'document'"
                  class="chatbot-message-document chatbot-soft-bg d-flex align-items-center gap-2 my-2 p-2 border border-light border-opacity-10 rounded-3 text-white text-decoration-none"
                  :href="part.href"
                  :data-download-href="part.href"
                  :title="part.href"
                >
                  <span class="chatbot-message-document-icon d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-2">
                    <i class="bi bi-file-earmark-pdf"></i>
                  </span>
                  <span class="d-flex flex-column overflow-hidden">
                    <span class="fw-semibold text-truncate">{{ part.text }}</span>
                    <span class="text-xs text-white-50">PDF report</span>
                  </span>
                </a>
                <span
                  v-else-if="part.type === 'list_marker'"
                  class="chatbot-message-list-marker fw-bold"
                >
                  {{ part.text }}
                </span>
                <strong
                  v-else-if="part.type === 'action_title'"
                  class="chatbot-message-action-title"
                >
                  {{ part.text }}
                </strong>
                <strong
                  v-else-if="part.type === 'strong'"
                  class="chatbot-message-strong"
                >
                  {{ part.text }}
                </strong>
                <em
                  v-else-if="part.type === 'emphasis'"
                  class="chatbot-message-emphasis"
                >
                  {{ part.text }}
                </em>
                <span v-else>{{ part.text }}</span>
              </template>
            </template>
          </div>
        </div>
      </div>

      <time
        v-if="format_message_timestamp(msg)"
        class="px-1 text-xs text-white-50"
        :datetime="get_message_created_at(msg)"
      >
        {{ format_message_timestamp(msg) }}
      </time>
    </div>
  </div>
</div>
